import { CLEAR_LOYALTY_ENROLMENT } from 'actions/actionConstants'
import { AppAction } from 'actions/ActionTypes'

function clearLoyaltyEnrolment(): AppAction {
  return {
    type: CLEAR_LOYALTY_ENROLMENT,
  }
}

export default clearLoyaltyEnrolment
